import {Button, Dropdown, Form, Input, Menu, Select} from "antd";
import {useEffect, useRef} from "react";
import {t} from "i18next";
import ApiService from "../../core/service/ApiService";
import {useUser} from "../../core/context/UserContext";
import {FileTypes} from "./files/AppointmentFiles";

export default function AppointmentFileEdit({fileRecord, onSaved}) {
    const formRef = useRef()
    const {user} = useUser()

    const onFinish = async (values) => {
        const res = await ApiService.Appointment.UpdateFileInformation(fileRecord?.appointmentId, fileRecord.id, {
            fileName: values.originalFileName,
            description: values.description,
            fileType: values.fileType,
        })

        if(res.success) {
            onSaved && onSaved()
        }
    }

    useEffect(() => {
        if(fileRecord) {
            formRef.current.setFieldsValue({
                ...fileRecord
            })
        }
    }, [fileRecord])

    return (
        <Form
            ref={formRef}
            layout="vertical"
            onFinish={onFinish}
        >
            <Form.Item
                name="originalFileName"
                label={t('Name')}
            >
                <Input />
            </Form.Item>

            <Form.Item
                name="description"
                label={t('Description')}
            >
                <Input
                    addonAfter={
                        <Dropdown
                            overlay={(
                                <Menu
                                    onClick={({key}) => {
                                        formRef.current.setFieldsValue({
                                            description: key,
                                        })
                                    }}
                                >
                                    {
                                        user?.fileDescriptions?.map(x => (
                                            <Menu.Item key={x.text}>
                                                <div style={{width: 300, wordWrap: 'break-word', whiteSpace: 'pre-wrap'}}>
                                                    {x.text}
                                                </div>
                                            </Menu.Item>
                                        ))
                                    }
                                </Menu>
                            )}
                            trigger={['click']}>
                            <Button size={'small'}>
                                {t('Description')}
                            </Button>
                        </Dropdown>
                    }
                />
            </Form.Item>
            <Form.Item
                name={'fileType'}
                label={t('File Type')}
            >
                <Select
                    style={{width: 200}}
                    size={'small'}
                >
                    {
                        FileTypes.map(x => (
                            <Select.Option key={x.id} value={x.id}>
                                {x.name}
                            </Select.Option>
                        ))
                    }
                </Select>
            </Form.Item>

            <Form.Item>
                <Button type="primary" htmlType="submit">{t('Save')}</Button>
            </Form.Item>
        </Form>
    )
}